import { SET_SPLUNK_LEARNING_LINK } from '../constants/actionTypes';
import * as dsaTypes from '../constants/dsaTypes';
import * as splunkLearningLinks from '../constants/splunkLearningLinks';

export const setSplunkLearningLink = (type = '') => {
  const link =  {
    [dsaTypes.FULL_DSA]: splunkLearningLinks.SPLUNK_LEARNING_FULL,
    [dsaTypes.NEW_CUSTOMER_DSA]: splunkLearningLinks.SPLUNK_LEARNING_NEW_CUSTOMER
  }[type] || splunkLearningLinks.SPLUNK_LEARNING_OVERVIEW;

  return dispatch => {
    dispatch({
      type: SET_SPLUNK_LEARNING_LINK,
      data: {
        splunkLearningLink: link
      }
    });
  };
};


// WEBPACK FOOTER //
// ./src/actions/stringActions.js